/**
 * Persistent per-device identifier used by the login API for licensing.
 * Generated once, stored in localStorage, and reused on every request.
 */

const KEY = 'chanakya.device.systemid';

function isValidUuid(v) {
  return (
    typeof v === 'string' &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v)
  );
}

function generateUuid() {
  // Prefer the native crypto UUID; fall back to a manual RFC-4122-ish v4.
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * Returns the persistent system id, creating one on first access.
 */
export function getSystemId() {
  if (typeof window === 'undefined') return 'server';
  try {
    const existing = localStorage.getItem(KEY);
    if (isValidUuid(existing)) return existing;
    const fresh = generateUuid();
    localStorage.setItem(KEY, fresh);
    return fresh;
  } catch {
    return generateUuid();
  }
}
